function e(g) {
  const t = Math.random() * 100, n = g.replace(/^\s*#|\s*$/g, ""), s = parseInt(n.substring(0, 2), 16), r = parseInt(n.substring(2, 4), 16), o = parseInt(n.substring(4), 16);
  return "#" + (0 | (1 << 8) + s + (256 - s) * t / 100).toString(16).substring(1) + (0 | (1 << 8) + r + (256 - r) * t / 100).toString(16).substring(1) + (0 | (1 << 8) + o + (256 - o) * t / 100).toString(16).substring(1);
}
export {
  e as randomShadeOfColour
};
//# sourceMappingURL=index4.js.map
